import { AnnouncementService } from './../../service/announcement.service';
import { Component, Injector, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { LaasOption } from 'src/app/core/models/laas-option';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { AnnouncementEditParams } from '../announcement/interface/announcement-edit-params';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { environment } from 'src/environments/environment';
import { getDataScopeByPermission, isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { endOfDay } from 'date-fns';


@Component({
  selector: 'laas-announcement-edit',
  templateUrl: './announcement-edit.component.html',
  styleUrls: ['./announcement-edit.component.scss']
})
export class AnnouncementEditComponent extends SessionBaseComponent implements OnInit {


  announcementEditForm: AnnouncementEditParams;

  text1: string = '<div>Hello World!</div><div>PrimeNG <b>Editor</b> Rocks</div><div><br></div>';

  facilityOptions: LaasOption[];
  announcementTypeOptions: LaasOption[];

  passSeqNo: number | null;

  checkBoxValue: boolean;

  firstSave: boolean;

  editMode: string;

  minDate: Date;

  showUpload: boolean;

  fileList: any[];

  inValidList: string[];

  isAdmin: boolean;

  userFacility: string[];

  readonly newPermissionCode: PermissionConstants = PermissionConstants.FacilityAnnouncementAdmin;

  fileToUpload: File | null = null;

  fileUploader = document.getElementById('file-uploader');

  readonly getFileUrl: string = `${environment.logisticsApiUrl}/announcementFileUpload/getAnnouncementFile`;

  constructor(injector: Injector, private formBuilder: FormBuilder, private dropdownOptionsService: DropdownOptionsService,
    private translate: TranslateService, private announcementService: AnnouncementService, private commonDataService: CommonDataService) {
      super(injector);

      this.facilityOptions = [];
      this.announcementTypeOptions = [];

      this.inValidList = [];

      this.announcementEditForm = {
        announcementTitle: null,
        announcementContent: null,
        facility: null,
        announcementStartDt: null,
        announcementEndDt: null,
        announcementType: null,
        importantFlag: 'N',
        updateUser: undefined,
        createUser: undefined,
        seqNo: null,
        editDocumentList: null,
        copySeqNo: null,
      }

      this.isAdmin = false;

      this.checkBoxValue = false;

      this.passSeqNo = null;

      this.firstSave = false;

      this.editMode = 'new';

      this.minDate = new Date();

      this.showUpload = false;

      this.fileList = [];

      this.userFacility = [];
  }



  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.dropdownOptionsService.getFacilityOptions().subscribe({
      next: async (result) => {
        await this.getDataScopeFacilityList();
        for (const facilityList of result) {
          if (this.userFacility.includes(facilityList.optionCode) || this.userFacility.length == 0) {
            this.facilityOptions.push( {label: facilityList.optionDesc, value: facilityList.optionCode} );
          }
        }
      }
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'ANNOUNCEMENT_TYPE').subscribe({
      next: result => {
        this.announcementTypeOptions = [...result].map((option: any) => {
          return {
            label: `${option.codeKey} - ${option.codeDesc}`,
            value: option.codeKey,
          }
        });
      }
    });
    if (this.routeStateService.getCurrent != null) {
      if (this.routeStateService.getCurrent().data != null) {
        let passParam = this.routeStateService.getCurrent().data.passParams;
        this.editMode = passParam.mode;
        this.passSeqNo = passParam.seqNo;
      }
      if (this.passSeqNo != null) {
        this.announcementService.searchAnnouncementEdit(this.passSeqNo).subscribe({
          next: (result) => {
            this.announcementEditForm.announcementContent = result.announcementContent;
            this.announcementEditForm.facility = result.facility;
            if (result.editDocumentList != null) {
              this.fileList = result.editDocumentList;
            }
            if (result.announcementEndDt != null) {
              this.announcementEditForm.announcementEndDt = new Date(result.announcementEndDt)
            }
            if (result.announcementStartDt != null) {
              this.announcementEditForm.announcementStartDt = new Date(result.announcementStartDt);
            }
            this.announcementEditForm.announcementTitle = result.announcementTitle;
            this.announcementEditForm.announcementType = result.announcementType;
            this.announcementEditForm.importantFlag = result.importantFlag;
            this.changeCheckBoxValue(result.importantFlag);
            if (this.editMode != 'copy') {
              this.announcementEditForm.seqNo = result.seqNo;
            } else {
              this.announcementEditForm.copySeqNo = result.seqNo;
            }
          }
        });
      }
    }

    this.announcementEditForm.updateUser = this.userProfile.userName;
      if (this.editMode != 'edit') {
        this.announcementEditForm.createUser = this.userProfile.userName;
    }

    this.minDate = new Date();
    this.isAdmin = this.permissionCodes.includes(this.newPermissionCode);
  }
  changeCheckBox(event: any) {
    if (event.checked) {
      this.announcementEditForm.importantFlag = 'Y';
    } else {
      this.announcementEditForm.importantFlag = 'N';
    }
  }

  changeCheckBoxValue(checkBoxValue: string | undefined){
    if (checkBoxValue != undefined) {
      if (checkBoxValue == 'Y') {
        this.checkBoxValue = true;
      } else{
      this.checkBoxValue = false;
      }
    } else {
      this.checkBoxValue = false;
    }
  }

  async saveAnnouncement(): Promise<void> {

    this.inValidList = [];
    this.validTitle();
    this.validFacilityParam();
    this.validDateParam();
    this.validTypeParam();
    this.validContentParam();
    if (this.inValidList.length == 0) {
      this.loader.show();
      this.announcementEditForm.updateUser = this.userProfile.userName;
      if (this.editMode != 'edit') {
        this.announcementEditForm.createUser = this.userProfile.userName;
      }
      this.announcementEditForm.editDocumentList = this.fileList;
      switch (this.editMode) {
        case 'edit': {
          this.announcementService.saveEditAnnouncement(this.announcementEditForm).subscribe({
            next: (result) => {
              this.loader.hide();
              this.toastService.success(this.translateService.instant('Announcement.Toast.SaveSuccess'));
              this.routeStateService.navigateTo('/Setting/FacilityAnnouncement', null);
            }
          });
          break;
        }
        case 'new': {
          this.announcementService.saveNewAnnouncement(this.announcementEditForm).subscribe({
            next: (result) => {
              this.loader.hide();
              this.toastService.success(this.translateService.instant('Announcement.Toast.SaveSuccess'));
              this.routeStateService.navigateTo('/Setting/FacilityAnnouncement', null);
            }
          });
          break;
        }
        case 'copy': {
          this.announcementService.saveCopyAnnouncement(this.announcementEditForm).subscribe({
            next: (result) => {
              this.loader.hide();
              this.toastService.success(this.translateService.instant('Announcement.Toast.SaveSuccess'));
              this.routeStateService.navigateTo('/Setting/FacilityAnnouncement', null);
            }
          });
          break;
        }
      }
    } else {
      let toastString = this.translateService.instant('Announcement.Toast.InvalidColumn');
      for (const toast of this.inValidList) {
        toastString = toastString + '\n' + toast;
      }
      this.toastService.warn(toastString);
    }
    this.firstSave = true;
  }

  cancel() {
    this.routeStateService.navigateTo('/Setting/FacilityAnnouncement', null);
  }

  getDate(check: string): Date {
    let newDt = new Date();
    if (check == 'start') {
      return newDt;
    } else {
      newDt.setMonth(newDt.getMonth() + 1);
      newDt.setDate(newDt.getDate() -1);
      return newDt;
    }
  }


  uploadClickBtn(event: any): void{
    this.showUpload = true;
  }

  async readAsDataURL(file: any): Promise<string | ArrayBuffer | null> {
    return new Promise((resolve, reject) => {
      let fileReader = new FileReader();
      fileReader.onload = function () {
        return resolve((fileReader.result as string)?.split(',')[1]);
      }
      fileReader.readAsDataURL(file);
    });
  }

  async uploadAnnouncementFile(event: any, fileUpload: any): Promise<void> {

    var regexAll = /[^\\]*\.(\w+)$/;
    let fileName: string = '';
    let fileType: string = '';
    let checkDuplicate: boolean = false;

    var total = event.target.files[0].name.match(regexAll);
    if (total != null) {
      fileName = (total[0].split('.')[0]);
      fileType = (total[1]);
    }

    for (const file of this.fileList) {
      if (file.name == fileName && file.type == fileType) {
        this.toastService.warn(this.translateService.instant('Announcement.Toast.DuplicateFile'))
        checkDuplicate = true;
        break;
      }
    }

    let fileBase64 = await this.readAsDataURL(event.target.files[0]);
    if (!checkDuplicate) {
      let oneFile = {
        seqNo: null,
        referenceKey: null,
        name: fileName,
        type: fileType,
        lastModified: event.target.files[0].lastModified,
        webkitRelativePath: event.target.files[0].webkitRelativePath,
        size: event.target.files[0].size,
        arrayBuffer: event.target.files[0].arrayBuffer,
        slice: event.target.files[0].slice,
        stream: event.target.files[0].stream,
        text: event.target.files[0].text,
        fileBase64: fileBase64,
        userId: this.userProfile.loginAccount
      }
      this.fileList.push(oneFile);
    }
    fileUpload.value = '';
  }

  deleteSelectFile(selectFile: any) {
    this.fileList.forEach((value, index) => {
      if(value.name == selectFile.name && value.type == selectFile.type) {
        this.fileList.splice(index,1);
      }
    });
  }

  view() {
    this.announcementEditForm.editDocumentList = this.fileList;
    let passAnnouncementPassParams = {announcementData: this.announcementEditForm, mode: 'editToView'};
    this.announcementService.setMessage(passAnnouncementPassParams);
    this.routeStateService.navigateTo('/Setting/FacilityAnnouncementView', passAnnouncementPassParams, true);
  }

  validContentParam() {
    if (this.announcementEditForm.announcementContent != null) {
      var onlyText = this.announcementEditForm.announcementContent.replace(/<[^>]*>/g, '');
      onlyText = onlyText.replace(/\s/g, "");
      if (isNullOrEmpty(onlyText)) {
        this.inValidList.push(this.translateService.instant('Announcement.Toast.ContentIsNull'));
        return;
      }
    }
    if (isNullOrEmpty(this.announcementEditForm.announcementContent)) {
      this.inValidList.push(this.translateService.instant('Announcement.Toast.ContentIsNull'));
    }
  }

  validDateParam() {
    if (this.announcementEditForm.announcementEndDt != null && this.announcementEditForm.announcementStartDt != null) {
      let today = endOfDay(new Date());
      if (this.announcementEditForm.announcementEndDt! < today!) {
        this.inValidList.push(this.translateService.instant('Announcement.Toast.EndDtLessThanNow'));
      } else if (this.announcementEditForm.announcementEndDt! < this.announcementEditForm.announcementStartDt!) {
        this.inValidList.push(this.translateService.instant('Announcement.Toast.EndDtLessThanStart'));
      }
    } else {
      this.inValidList.push(this.translateService.instant('Announcement.Toast.DateNull'));
    }
  }

  validFacilityParam() {
    if (isNullOrEmpty(this.announcementEditForm.facility)) {
      this.inValidList.push(this.translateService.instant('Announcement.Toast.FacilityIsNull'));
    }
  }

  validTypeParam() {
    if (isNullOrEmpty(this.announcementEditForm.announcementType)) {
      this.inValidList.push(this.translateService.instant('Announcement.Toast.TypeIsNull'));
    }
  }
  validTitle() {
    if (isNullOrEmpty(this.announcementEditForm.announcementTitle)) {
      this.inValidList.push(this.translateService.instant('Announcement.Toast.TitleIsNull'));
    }
  }

  downloadAnnouncementFile(docId: string, name: string, type:string): void {
    this.announcementService.downloadAnnouncementFile(docId, name, type).subscribe(result => {
      var blob = new Blob([result], { type: 'application/octet-stream' }); // application後面接下載的副檔名
      let downloadURL = window.URL.createObjectURL(blob);
      let link = document.createElement('a');
      link.href = downloadURL;
      link.download = `${name}.${type}`;
      link.click();
    });
  }

  async getDataScopeFacilityList(): Promise<void> {
    const dataScopList = getDataScopeByPermission(this.userProfile, PermissionConstants.FacilityAnnouncementAdmin);
    this.userFacility = dataScopList.map((x:any) =>{ return x.facility; }).filter((x:any) => !isNullOrEmpty(x));
  }

  dateOnChange(date: any, type: string) {
    switch (type) {
      case 'announcementDt':
        this.announcementEditForm.announcementStartDt = date.startDate;
        this.announcementEditForm.announcementEndDt = date.endDate ? date.endDate : endOfDay(new Date().setHours(23, 59, 59, 999));
        break;
    }
  }

  checkRequiredField = (): boolean => {
    return this.announcementEditForm.announcementStartDt == undefined && this.firstSave;
  }
}

